import { SidebarMenu, SidebarMenuItem } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { logoutThunk } from '@backrs_ui/grow-ui/src/redux/session/logoutThunk';

import { SectionDependencies } from './menuSections.hook';

const PROFILE_POPUP_TITLES = appStrings.modules.backrsPageShell.menuItems.profile;

const getAccountTopSectionItems = (
  navigate: SectionDependencies['navigate'],
  userId: number | undefined,
  isUnauth: boolean,
): SidebarMenuItem[] => {
  const items: SidebarMenuItem[] = [
    {
      leftIcon: {
        iconName: 'User01',
      },
      title: PROFILE_POPUP_TITLES.viewProfile,
      variant: {
        type: 'NAVIGATION_ITEM',
        onClick: () => navigate(`${APP_ROUTE.PROFILE}/${userId}`),
        isActive: false,
      },
    },
    {
      leftIcon: {
        iconName: 'Settings01',
      },
      title: PROFILE_POPUP_TITLES.accountSettings,
      variant: {
        type: 'NAVIGATION_ITEM',
        onClick: () => navigate(APP_ROUTE.SETTINGS),
        isActive: false,
      },
    },
    {
      leftIcon: {
        iconName: 'BookOpen01',
      },
      title: PROFILE_POPUP_TITLES.myStory,
      variant: {
        type: 'NAVIGATION_ITEM',
        onClick: () => navigate(`${APP_ROUTE.PROFILE}?tab=Story`),
        isActive: false,
      },
    },
  ];

  if (isUnauth) {
    return items.map((item) => ({
      ...item,
      hidden: true,
    }));
  }

  return items;
};

const accountBottomSectionItems = ({
  dispatch,
  postHog,
  navigate,
}: Pick<SectionDependencies, 'dispatch' | 'postHog' | 'navigate'>): SidebarMenuItem[] => {
  return [
    {
      leftIcon: {
        iconName: 'LogOut01',
      },
      title: PROFILE_POPUP_TITLES.signOut,
      variant: {
        type: 'NAVIGATION_ITEM',
        onClick: () => {
          navigate(APP_ROUTE.LOGIN);
          dispatch(logoutThunk({ postHog }));
        },
        isActive: false,
      },
    },
  ];
};

const unauthAccountBottomSectionItems = ({
  navigate,
}: Pick<SectionDependencies, 'navigate'>): SidebarMenuItem[] => {
  return [
    {
      leftIcon: {
        iconName: 'LogIn01',
      },
      title: PROFILE_POPUP_TITLES.logIn,
      variant: {
        type: 'NAVIGATION_ITEM',
        onClick: () => {
          navigate(APP_ROUTE.LOGIN);
        },
        isActive: false,
      },
    },
  ];
};

export const popupSectionMenuItems = ({
  dispatch,
  postHog,
  navigate,
  isUnauthenticated,
  userId,
}: SectionDependencies): SidebarMenu['accountMenuItems'] => {
  return {
    topSectionItems: getAccountTopSectionItems(navigate, userId, isUnauthenticated),
    bottomSectionItems: isUnauthenticated
      ? unauthAccountBottomSectionItems({ navigate })
      : accountBottomSectionItems({ dispatch, postHog, navigate }),
  };
};
